import PropTypes from 'prop-types';
import React from 'react';

const MoneyIcon = ({ color }) => (
  <svg width="41" height="72" viewBox="0 0 41 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.9131 4.008C14.9131 7.749 14.649 8.123 10.9534 9.612C4.85431 12.068 1.00875 17.086 1.00875 22.584C1.00875 31.407 5.7283 35.843 19.4221 39.892C27.443 42.264 30.8108 44.9 30.789 48.789C30.7602 53.825 27.5294 56 20.0786 56C14.8029 56 10.5899 53.613 9.44276 49.974C8.94617 48.4 7.92817 48 4.4183 48C-0.473061 48 -1.03023 49.075 1.41098 53.8C3.34667 57.545 6.82575 60.624 11.2027 62.466C14.6082 63.899 14.9131 64.355 14.9131 68.013V72H20.8722H26.8312V67.5C26.8312 63.882 27.1718 62.999 28.5692 62.996C33.836 62.985 40.7247 55.177 40.7316 49.21C40.7415 40.712 34.7041 35.142 21.0797 31.077C10.5928 27.949 7.62029 24.115 11.7241 19.012C12.9347 17.507 14.9886 16.633 18.1638 16.273C24.4317 15.561 28.752 17.419 29.4919 21.144C30.0222 23.817 30.3699 24 34.9007 24C37.5664 24 39.7424 23.536 39.7424 22.968C39.7424 18.651 31.8268 9 28.2862 9C27.2235 9 26.8312 7.786 26.8312 4.5V0H20.8722H14.9131V4.008Z" fill={color} />
  </svg>
);

MoneyIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default MoneyIcon;
